<div class="max-h-[200px] overflow-auto py-1">
  @for(contact of contacts; track contact.contactId) {
  <interface-contacts-drop-down-item
    [contact]="contact"
    (click)="onSelect(contact)"
  ></interface-contacts-drop-down-item>
  }
</div>
